import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import PacksSelect from './Components/PacksPages/PacksSelect';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import PacksProvider from './Components/Context/PacksContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function PacksSelectRoute() {
    return (
        <UserInfoProvider>
            <PacksProvider>
                <MedicalContextProvider>
                    <div className="PacksSelectRoutePage">
                        <div className="PacksSelectRouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="PacksSelectRoute">
                            <PacksSelect/>
                        </div>
                        {/*<div className="PacksSelectRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </PacksProvider>
        </UserInfoProvider>
    );
}

export default PacksSelectRoute;